import React from 'react'
import Grid from '@material-ui/core/Grid'
import getUrl from 'front-end-core/core/url'
import TextLink from 'components/redesign/TextLink'
import { LEGISLATION_FOLDERS } from 'constants/controllers'

export default ({ aol }) => (
  <div className='layout-width-constraint pt9'>
    <Grid container className='f5'>
      <Grid item>
        <div>
          <TextLink
            text='Legislation menu'
            textCx='mb4'
            url={getUrl(LEGISLATION_FOLDERS, { aol })}
          />
        </div>
      </Grid>
    </Grid>
  </div>
)
